<template>
  <v-card>
    <v-app-bar
        dark
        color="green"
    >
       <v-toolbar-title>{{ title }} ({{symbol}})</v-toolbar-title>
   </v-app-bar>

    <v-card-text>
      <v-row>
        <v-col cols="8">
          <div v-html="hashtag(summary)"/>
        </v-col>
        <v-col cols="4">
          <v-progress-circular
              v-if="!loaded"
              indeterminate
              color="primary"
          ></v-progress-circular>
          <line-chart v-if="loaded" :chartdata="chartdata" :options="options"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios';
import LineChart from "@/components/LineChart";
export default {
  name: "SeedPosition",
  components: {LineChart},
  props: [
      'title',
      'symbol',
      'summary',
  ],
  data() {
    return {
      chartdata: {},
      options: {},
      show : false,
      loaded: false,
    };
  },
  methods: {
    hashtag: function (value) {
      let matches = value.match(/\B(\#[a-zA-Z]+\b)(?!;)/g);

      if (matches) {
        matches.forEach((m) => {
          value = value.replace(m, `<strong>${m}</strong>`);
        });
      }

      return value;
    }
  },
  computed: {

  },
  async mounted () {
    this.loaded = false
    try {
      let resp = await axios.get(`https://us-central1-thetafarm-e46e9.cloudfunctions.net/chart?symbol=${this.symbol}`);

      let points = [];
      let labels = [];
      resp.data.chart.forEach( (e) => {
        points.push(e.close);
        labels.push(e.date);
      })

      this.chartdata = {
        labels: labels,
        datasets: [
          {
            backgroundColor: '#187e16',
            data: points
          }
        ]
      };

      this.options = {
        title: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        }
      };

      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style scoped>

</style>